import { useQuery } from '@tanstack/react-query';

import { Declaration, DeclarationStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  status: DeclarationStatus;
}

export const useDeclarationsByBatchIdAndStatus = ({ batchId, status }: HookProps) =>
  useQuery({
    queryKey: ['declarations', batchId, status],
    queryFn: async (): Promise<Declaration[]> => {
      try {
        const { data } = await request({
          path: `declarations/retrieve-by-status/${batchId}/${status}`,
          method: 'POST',
          authenticate: true,
        });

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarations by batch and status');
      }
    },
    placeholderData: [],
  });
